import React from 'react'
import styled from 'styled-components'
import Drawer, { DrawerProps } from '@material-ui/core/Drawer';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import List from '@material-ui/core/List';
import { Link, LinkProps, useHistory, useLocation } from 'react-router-dom'
import { signOut } from '@aws-amplify/auth'

import { Flex } from '../styles/global'
import { AUTH_USER_TOKEN_KEY, checkAdmin } from '../utils/auth.utils'

export const menuRoutes = [
  {
    name: 'Simulations',
    route: '/',
    icon: '',
  },
  {
    name: 'Pathogens',
    route: '/pathogens',
    icon: '',
    adminOnly: true,
  },
  {
    name: 'Symptoms',
    route: '/symptoms',
    icon: '',
    adminOnly: true,
  },
  {
    name: 'Interventions',
    route: '/interventions',
    icon: '',
    adminOnly: true,
  },
]


export const Menu = () => {
  const history = useHistory();
  const location = useLocation();
  const isAdmin = checkAdmin();

  return (
    <div>
      <MenuDrawer
        variant="permanent"
        anchor="left"
      >
        <Branding direction="column" justify="center" alignItems="flex-start">
          <h4>Epidesigner</h4>
        </Branding>
        <Divider />
        <List>
          {menuRoutes.map((item, index) => {
            const isActive = location.pathname === item.route;
            if (!item.adminOnly || (item.adminOnly && isAdmin)) {
              return (
                <StyledLink key={item.name} to={item.route}>
                  <ListItem button key={item.name} style={{ borderLeft: isActive ? '4px solid #3f51b5' : 'none' }}>
                    <ListItemText
                      primary={item.name}
                      primaryTypographyProps={{
                        style: {
                          fontWeight: isActive ? 700 : 400,
                          color: isActive ? '#3f51b5' : '#000'
                        }
                      }}
                    />
                  </ListItem>
                </StyledLink>
              )
            }
            return null
          })}
          <div>
            <ListItem
              button
              key='signout'
              onClick={async () => {
                try {
                  await signOut()
                } catch (error) {
                  console.error('Error signing out: ', error)
                }
                localStorage.removeItem(AUTH_USER_TOKEN_KEY)
                history.push('/login');
              }}
            >
              <ListItemText primary="Sign Out" />
            </ListItem>
          </div>
        </List>
        <Divider />
      </MenuDrawer>
    </div>
  )
}

const StyledLink = styled(Link) <LinkProps>`
  text-decoration: none;
  color: #000;
` as typeof Link;

const MenuDrawer = styled(Drawer) <DrawerProps>`
    .MuiPaper-root {
        width: 200px;
    }
` as typeof Drawer;

const Branding = styled(Flex)`
  padding: 18px 16px 12px;

  > h4 {
    margin: 0;
    padding: 0;
    font-size: 28px;
    font-family: Roboto, 'Open Sans', 'Helvetica Neue', sans-serif;
    font-weight: 300;
    text-align: left;
  }

  > img {
    width: 100px;
  }
`
